import React, { FC } from 'react';

import { EvIcon, EvLink } from '@evinced-private/ui-common';

import JiraLogoIcon from 'src/common/components/icons/JiraLogoIcon.svg?raw';

import './ExternalTicketFormatter.scss';

export interface IExternalTicket {
	key: string;
	link: string;
}

interface IExternalTicketFormatterProps {
	tickets?: IExternalTicket[];
}

export const ExternalTicketFormatter: FC<IExternalTicketFormatterProps> = ({ tickets }) => {
	if (!tickets || tickets.length === 0) {
		return null;
	}

	return (
		<div className="external-ticket-formatter">
			{tickets.map(({ link, key }) => (
				<EvLink
					key={key}
					url={link}
					openInNewTab
					customLink={
						<>
							<EvIcon icon={JiraLogoIcon} className="jira-logo" />
							<span>{key.toUpperCase()}</span>
						</>
					}
				/>
			))}
		</div>
	);
};
